module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "identifier": "oekonomi.unpaidInvoices",
      "placement": "left"
    }
  }), _vm._v("\n        Fakturaer, der ikke er betalt (" + _vm._s(_vm.employeeName) + ")\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                " + _vm._s(props.row.description) + "\n            ")]) : (props.column.field == 'invoice_number') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.invoice_number ? props.row.invoice_number : '-') + "\n            ")]) : (props.column.field == 'external_id') ? _c('div', {
          staticClass: "table-column__external-id"
        }, [_vm._v("\n                " + _vm._s(props.row.external_id) + "\n            ")]) : (props.column.field == 'due_at') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.due_at, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'amount') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.amount)) + "\n            ")]) : (props.column.field == 'paid') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.paid) ? _c('span', [_vm._v("\n                    Betalt\n                ")]) : _c('span', [_vm._v("\n                    Ikke betalt\n                ")])]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 2812794680)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2531836a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsibles/learning/components/tables/unpaid.vue
// module id = 825
// module chunks = 0